import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseComponent} from './commons/base-component/base.component';
import {RatingStarsComponent} from './widgets/rating-stars/rating-stars.component';
import {SocialShareComponent} from './widgets/social-share/social-share.component';
import {AlertComponent} from './widgets/alert/alert.component';
import {GrowlModule} from 'primeng/growl';
import { MessageService } from 'primeng/components/common/messageservice';
import { GeoBlockedComponent } from './geo-blocked/geo-blocked.component';
import { FormsModule } from '@angular/forms';
import { CookieConsentComponent } from './widgets/cookie-consent/cookie-consent.component';

@NgModule({
  imports: [
    CommonModule,
    GrowlModule,
    FormsModule

  ],
  declarations: [
    BaseComponent,
    SocialShareComponent,
    RatingStarsComponent,
    AlertComponent,
    GeoBlockedComponent,
    CookieConsentComponent,
  ],
  exports: [
    BaseComponent,
    SocialShareComponent,
    RatingStarsComponent,
    AlertComponent,
    CookieConsentComponent,
  ],
  providers: [MessageService]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/shared.module.ts